import { z } from "zod";

export const BaseOutputSchema = z.object({
    errorMessage: z.string().nullable().default(null),
    infoMessage: z.string().nullable().default(null),
});

export type BaseOutput = z.infer<typeof BaseOutputSchema>;